import React from 'react';

import { connect } from 'react-redux';

import ComponentWrapper from '../../common/ComponentWrapper';
import { withStyles } from '@mui/styles';
import { Button } from '@mui/material';

import LoaderNew from '../../common/LoaderNew';

import AutocompleteSelect from '../../common/AutocompleteSelect';

import ImportedApp from './components/ImportedApp';
import CommonStyles from '../../common/CommonStyles';
import TrplForm from '../../common/TrplForm/TrplForm';
import TrplFormFullScreenDialog from '../../common/TrplForm/TrplFormFullScreenDialog';
import ActionConfirmation from '../../common/ActionConfirmation';

const styles = {
  mainContainer: {
    padding: '0px 30px',
  },
  deleteIcon: {
    marginLeft: '20px',
    color: '#C4C4C4',
    width: '24px',
    '&:hover': {
      color: '#E91818',
      transition: '.2s',
    },
  },
  ...CommonStyles,
};

class ImportsPage extends ComponentWrapper {
  state = {
    deletingApp: false,
    loadedImports: false,
    loaded: true,
    appsForImport: [],
    trplFormModal: {
      mode: 'create',
      node: {},
      rst: {},
      trpl: {},
    },
    setupIntents: [],
    selectedAppForImport: '',
    trplFormModalShowPids: [],
    trplFormModalOpened: false,
    deleteImportModal: {
      isOpened: false,
    },
  };

  componentDidMount() {
    document.title="Imports | Milkyweb";

    this.getIntentsAndImports();
  };

  getIntentsAndImports = () => {
    this.setState({ loadedImports: false }, () => {
      this.get({
        url: '/get_jel?type=["trpls_frm"]&meta_query=["app_intents", "imports", "potential_imports", "app_impls"]',
        cb: (res) => {
          if (res) {
            const { app_intents, potential_imports, imports, app_impls } = res._meta_query;

            this.combineIntentsToForms(res.imported, app_intents, imports);
            this.collectPotentialImportsValues(potential_imports);

            this.setState({
              imports,
              app_impls,
              app_intents,
              potential_imports,
              imported: res.imported,
              loadedImports: true,
              loaded: true,
            });
          }
        },
        disableNotify: true,
      });
    });
  };

  deleteImportedApp = () => {
    const { deleteImportModal } = this.state;

    this.setState({ deletingApp: true, loadedImports: false }, () => {
      this.postWithData({
        url: '/rest/remove_imported_app',
        data: {
          id: +deleteImportModal.appId,
        },
        cb: (data) => {
          if (data._status === 'error') {
            console.log(data);
          } else {
            this.getIntentsAndImports();
            this.toggleDeleteAppModal(false);
          };
        }
      });
    })
  };

  toggleDeleteAppModal = (isOpened, title, appId) => {
    const { deleteImportModal } = this.state;

    deleteImportModal.isOpened = isOpened;
    deleteImportModal.title = title;
    deleteImportModal.appId = appId;

    this.setState({ deleteImportModal });
  };

  onImportButtonClick = () => {
    const { selectedAppForImport } = this.state;

    if (+selectedAppForImport.value === 15) {
      window.location =`/dashboard?i=15`;
    } else {
      this.setState({ loaded: false }, () => {
        this.postWithData({
          url: '/rest/import_app',
          data: {
            id: +selectedAppForImport.value,
          },
          cb: (data) => {
            if (data._status === 'error') {
              console.log(data);
            } else {
              this.setState({
                selectedAppForImport: '',
              }, ()=> {
                this.getIntentsAndImports();
              });
            }
          }
        });
      })
    }
  };

  openTrplFormFull = (params) => {
    const { concept, node, mode, groups, title, formId, tabs } = params;
    const { trplFormModal } = this.state;

    trplFormModal.node = node;
    trplFormModal.mode = mode;
    trplFormModal.title = title ? title : 'Edit';
    trplFormModal.groups = groups;
    trplFormModal.id = formId;
    trplFormModal.concept = concept;
    trplFormModal.tabs = tabs;

    this.setState(
      {
        trplFormModal,
      },
      () => {
        this.setState({
          trplFormModalOpened: true,
        });
      }
    );
  };

  prepareImportsData = () => {
    const { app_intents, potential_imports, imports, imported } = this.state;

    this.combineIntentsToForms(imported, app_intents, imports);
    this.collectPotentialImportsValues(potential_imports);
    this.setState({ loaded: true });
  };

  closeTrplFormModal = () => {
    let { trplFormModal } = this.state;

    trplFormModal = {
      mode: 'create',
      node: {},
      groups: [],
    };

    this.setState({
      trplFormModal,
      trplFormModalOpened: false,
    }, () => this.prepareImportsData());
  };

  combineIntentsToForms = (imported, app_intents, imports) => {

    let setupIntents = [];

    imports && imports.length && imports.forEach(importedApp => {
      const appKey = +Object.keys(importedApp)[0];
        let viewsBySetup = imported && imported.map(jel => {
         if (+jel.app_id === appKey) return jel;
         return null
        });
        
        viewsBySetup && viewsBySetup.length && app_intents.length && app_intents.forEach(intent => {
          if (intent.sourceApp === appKey) {
            const appIntent = Object.assign({}, viewsBySetup[0].trpls_frm.find(view => view.id === intent.formId));
            appIntent.iid = intent.iid;
            appIntent.source = intent.sourceApp;
            appIntent.complete = intent.complete;
            setupIntents.push(appIntent);
          }
        })
    });

    this.setState({ setupIntents });
  };

  collectPotentialImportsValues = (potential_imports) => {
    const appsForImport = [];
    potential_imports.length && potential_imports.forEach(app =>
      appsForImport.push({ label: `${Object.keys(app)[0]} : ${Object.values(app)[0]}`, value: Object.keys(app)[0] })
    );

    this.setState({ appsForImport, deletingApp: false, loadedImports: true });   
  };

  render() {
    const {
      classes,
    } = this.props;

    const {
      loaded,
      imports,
      app_impls,
      deletingApp,
      setupIntents,
      appsForImport,
      trplFormModal,
      loadedImports,
      deleteImportModal,
      trplFormModalOpened,
      selectedAppForImport,
      trplFormModalShowPids,
    } = this.state;

    return (
      <React.Fragment>
        <ActionConfirmation
          loadingConfirm={deletingApp}
          modalData={{
            open: deleteImportModal.isOpened,
            contentText: "Delete Imported Application",
            contentBoldText: `${deleteImportModal.appId}: ${deleteImportModal.title}?`,
          }}
          acceptHandler={this.deleteImportedApp}
          onClose={() => this.toggleDeleteAppModal(false, '', '')}
        />

        <div className={`${classes.container} ${classes.ml20}`}>
          <TrplFormFullScreenDialog
            isOpen={trplFormModalOpened}
            paperFullScreenStyles={classes.trplFormPaper}
          >
            <div className={classes.pb120}>
              <TrplForm
                formId={trplFormModal.id}
                mode={trplFormModal.mode}
                tabs={trplFormModal.tabs}
                iId={trplFormModal.node.id}
                groups={trplFormModal.groups}
                title={`${trplFormModal.title}`}
                show_pids={trplFormModalShowPids}
                updateParentData={this.updateData}
                closeModal={this.closeTrplFormModal}
                formConceptId={trplFormModal.concept}
                paperFullScreenStyles={classes.tprlFormPaper}
              />
            </div>
          </TrplFormFullScreenDialog>

          <div style={{ display: 'flex', background: '#ffff', marginTop: '30px', padding: '10px', width: '500px' }}>
            <AutocompleteSelect
              fullWidth
              margin="none"
              disableunderline
              complicatedValues
              options={appsForImport}
              value={selectedAppForImport}
              placeholder="Select application"     
              style={{ width: '-webkit-fill-available' }}                      
              onChange={(option) => {
                this.setState({ selectedAppForImport: option });
              }}
            />
              <Button
                size="small"
                style={{ marginLeft: '10px', width: '75px' }}
                disabled={selectedAppForImport === ''}
                onClick={(() => {
                  this.onImportButtonClick();
                  }
                )}
                className={`${classes.btn} ${classes.btnNormal}`}
              >
                {loaded ? 'Import' : <LoaderNew />}
              </Button>
          </div>

          {loadedImports ?
          <div style={{ display: 'grid', marginBottom: '10px', marginTop: '20px' }}>
            {imports && imports.length && loadedImports ?
              <React.Fragment>
                <span style={{ margin: '10px 0 15px 20px', fontSize: 20, fontWeight: 600, color: '#4c4c4c' }}>
                  Imported Applications
                </span>

                <div style={{ display: 'inline-flex', flexWrap: 'wrap', flexDirection: 'row' }}>
                  {imports.map((importedApp, appIndex) => {
                    let appId = Object.keys(importedApp)[0];
                    let appTitle = Object.values(importedApp)[0];
                    return (
                      <div key={appIndex} className={`${classes.p20} ${classes.mr10} ${classes.mb10}`} style={{ background: '#FDFDFD', width: 'fit-content' }}>
                        <ImportedApp
                          appId={appId}
                          classes={classes}
                          appTitle={appTitle}
                          setupIntents={setupIntents}
                          app_impls={app_impls[appId]}
                          openTrplFormFull={this.openTrplFormFull}
                          toggleDeleteAppModal={this.toggleDeleteAppModal}
                        />
                      </div>
                    )
                  })}
                </div>
              </React.Fragment>
            : null}
          </div>
          :
          <div
            style={{
              display: 'flex',
              paddingTop: '50px',
              justifyContent: 'center',
            }}
          >
            <LoaderNew />
          </div>
          }
        </div>
      </React.Fragment>
    )
  }
};

export default connect((state) => ({
  setup: state.meta.setup,
  account: state.meta.account,
}), {})(withStyles(styles)(ImportsPage));
